module.exports = __webpack_public_path__ + "img/blink.4efd2af3.gif";